document.addEventListener('DOMContentLoaded', function () {
  const main = document.querySelector('main.silk-road')
  if (!main) return

  const inViewObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-show')
          observer.unobserve(entry.target)
        }
      })
    },
    {
      threshold: 0,
      rootMargin: '0px 0px -10% 0px',
    },
  )

  function setInViewObserver() {
    const currentItems = main.querySelectorAll('.js_sub_tab_content.is-current .in-view')

    currentItems.forEach(function (item) {
      if (!item.classList.contains('is-show')) {
        inViewObserver.observe(item)
      }
    })
  }

  const params = new URLSearchParams(window.location.search)
  const tabParam = params.get('tab')
  const subTabParam = params.get('sub-tab')

  if (tabParam && subTabParam) {
    const targetTabContent = main.querySelector(`.js_tab_content[data-tab-content="${tabParam}"]`)

    if (targetTabContent) {
      const targetSubTabBtn = targetTabContent.querySelector(
        `.js_sub_tab_btn[data-tab="${subTabParam}"]`,
      )

      const targetSubTabContent = targetTabContent.querySelector(
        `.js_sub_tab_content[data-tab-content="${subTabParam}"]`,
      )

      if (targetSubTabBtn && targetSubTabContent) {
        targetTabContent.querySelectorAll('.js_sub_tab_btn').forEach(function (btn) {
          btn.classList.remove('is-current')
        })

        targetTabContent.querySelectorAll('.js_sub_tab_content').forEach(function (content) {
          content.classList.remove('is-current')
        })

        targetSubTabBtn.classList.add('is-current')
        targetSubTabContent.classList.add('is-current')
      }
    }
  }

  setInViewObserver()

  window.addEventListener('resize', setInViewObserver)

  document.querySelectorAll('.js_sub_tab_btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setTimeout(function () {
        setInViewObserver()
      }, 50)
    })
  })

  document.querySelectorAll('.js_tab_btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setTimeout(function () {
        setInViewObserver()
      }, 50)
    })
  })
})
